// Budgeting endpoints. The Axios singleton's baseURL already includes
// `/api/v1`, so paths here are relative to it (see `src/lib/api.ts`).
//
// Note the two prefixes, which mirror where each ViewSet is mounted in the
// backend (`api/urls.py` vs `api/url/v1_1.py`):
//   - budget read, capability, and upload are under `/api/v1/v1.1/...`
//     -> prefixed with `v1.1/` here.
//   - zone management is mounted at `/api/v1/...`
//     -> no `v1.1/` prefix.
export const BUDGETING_ENDPOINTS = {
  // Server-authoritative capability the wizard reads. Returns
  // `{ "budgeting": <bool> }`; the client is display-only and fails closed.
  GET_CAPABILITIES: 'v1.1/budgeting/capabilities/',

  // Project-scoped zones. The project id is a URL path segment (VDP-1246
  // brought the zone ViewSet onto the VDP-1056 project-scoped standard); mounted
  // under `/api/v1/` (no `v1.1/` prefix). Returns a list of
  // `{ id, project, name, is_active }`.
  LIST_ZONES: (projectId: string) => `budgeting/projects/${projectId}/zones/`,

  // Read a persisted budget as a grouped view
  // (`?group_by=cost_centre|wbs|zone`).
  GET_BUDGET: (budgetId: string) => `v1.1/budgeting/budget/${budgetId}/`,

  // Upload a budget spreadsheet for a project (project id is a path segment,
  // per the VDP-1056 project-scoped standard).
  UPLOAD_BUDGET: (projectId: string) =>
    `v1.1/budgeting/projects/${projectId}/budget/upload/`,

  // Save a manually-built budget for a project. POST the flat `EditableBudget`
  // body; the server answers 201 with `{ reference }`. Project id is a path
  // segment (VDP-1056 project-scoped standard).
  SAVE_BUDGET: (projectId: string) =>
    `v1.1/budgeting/projects/${projectId}/budget/`,

  // Read a persisted budget in the flat, editable shape the Create Budget grid
  // consumes (distinct from the grouped `GET_BUDGET` read view). Both the
  // project id and the budget reference are path segments.
  GET_BUDGET_FOR_EDIT: (projectId: string, reference: string) =>
    `v1.1/budgeting/projects/${projectId}/budget/${reference}/edit/`,
} as const;
